import "@fontsource-variable/space-grotesk";
import "@fontsource-variable/inter";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import { reportRuntimeError } from "@/runtime/runtimeErrors";
import "@/styles/global.css";

const root = document.getElementById("root");

if (!root) throw new Error("Application root element is missing.");

// Capture phase so asset load failures (which do not bubble) are seen too.
window.addEventListener("error", (event) => {
  if (event.error) reportRuntimeError(event.error, "Runtime error");
  else if (event.target && typeof event.target === "object" && "src" in event.target) {
    reportRuntimeError(new Error(`Failed to load ${String(event.target.src)}`), "Asset loading error");
  }
}, true);

window.addEventListener("unhandledrejection", (event) => {
  reportRuntimeError(event.reason, "Unhandled promise rejection");
});

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
